import { dataStopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStopSolid = /*#__PURE__*/createIcon(dataStopSolid)
export default IconStopSolid
